import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import FlexibleTextarea from '@/components/Inputs/FlexibleTextarea';
import useColor from '@/hooks/domain/useColor';

type FilterItemProps = {
  text: string;
  onBlur?: () => void;
  readOnly?: boolean;
  onChange?: (value: string) => void;
  actionButton?: React.ReactNode;
  placeholder?: string;
  initFocus?: boolean;
};

const FilterItemText = ({
  initFocus,
  readOnly,
  onChange,
  onBlur,
  text,
  actionButton,
  placeholder,
}: FilterItemProps) => {
  const color = useColor();
  const inputStyle: CSSProperties = {
    width: '100%',
    fontSize: '12px',
    padding: '12px 14px',
    borderRadius: '6px',
  };

  if (readOnly) {
    inputStyle.maxHeight = '144px';
    inputStyle.backgroundColor = color.gray200;
    inputStyle.border = 'unset';
    inputStyle.cursor = 'default';
  }

  return (
    <StyledFilterWrapper a="center" g={4}>
      <FlexibleTextarea
        initFocus={initFocus}
        readOnly={readOnly}
        showBorder
        value={text}
        onChange={(e) => {
          onChange && onChange(e.target.value);
        }}
        onBlur={onBlur}
        placeholder={placeholder || 'Enter text'}
        style={inputStyle}
      />

      {actionButton}
    </StyledFilterWrapper>
  );
};

const StyledFilterWrapper = styled(Flex).attrs({
  a: 'center',
  g: 4,
  f: 1,
})`
  .delete-button {
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    .delete-button {
      opacity: 1;
    }
  }
`;

export default FilterItemText;
